import type { ReactElement, SVGProps } from 'react';

import type { IconSVGProps } from './types';

/**
 * ReferencesIcon: ícono para “referencias”.
 */
export const ReferencesIcon = ({
  className,
  width = 16,
  height = 17,
  ...props
}: IconSVGProps): ReactElement<SVGProps<SVGSVGElement>> => {
  return (
    <svg
      viewBox="0 0 16 17"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      aria-hidden
      focusable="false"
      {...props}
    >
      <path
        d="M2.4 7.70002C3.2825 7.70002 4 6.98252 4 6.10002C4 5.21752 3.2825 4.50002 2.4 4.50002C1.5175 4.50002 0.8 5.21752 0.8 6.10002C0.8 6.98252 1.5175 7.70002 2.4 7.70002ZM13.6 7.70002C14.4825 7.70002 15.2 6.98252 15.2 6.10002C15.2 5.21752 14.4825 4.50002 13.6 4.50002C12.7175 4.50002 12 5.21752 12 6.10002C12 6.98252 12.7175 7.70002 13.6 7.70002ZM14.4 8.50002H12.8C12.36 8.50002 11.9625 8.67753 11.6725 8.96502C12.68 9.51753 13.395 10.515 13.55 11.7H15.2C15.6425 11.7 16 11.3425 16 10.9V10.1C16 9.21753 15.2825 8.50002 14.4 8.50002ZM8 8.50002C9.5475 8.50002 10.8 7.24752 10.8 5.70002C10.8 4.15252 9.5475 2.90002 8 2.90002C6.4525 2.90002 5.2 4.15252 5.2 5.70002C5.2 7.24752 6.4525 8.50002 8 8.50002ZM9.92 9.30002H9.7125C9.1925 9.55002 8.615 9.70003 8 9.70003C7.385 9.70003 6.81 9.55002 6.2875 9.30002H6.08C4.49 9.30002 3.2 10.59 3.2 12.18V12.9C3.2 13.5625 3.7375 14.1 4.4 14.1H11.6C12.2625 14.1 12.8 13.5625 12.8 12.9V12.18C12.8 10.59 11.51 9.30002 9.92 9.30002ZM4.3275 8.96502C4.0375 8.67753 3.64 8.50002 3.2 8.50002H1.6C0.7175 8.50002 0 9.21753 0 10.1V10.9C0 11.3425 0.3575 11.7 0.8 11.7H2.4475C2.605 10.515 3.32 9.51753 4.3275 8.96502Z"
        fill="inherit"
      />
    </svg>
  );
};
